import { PriceSuggestionType } from '@retail/products/types';
import { PriceDateDTO } from '../../dto';
import {
  CustomerMarkupCondition,
  FreightCondition,
  MarkupCondition,
  PriceSuggestionCondition,
  PurchaseCondition,
  RoundingCondition,
} from '@retail/calculus/types';
import { Prices } from '../Prices';
import { PriceRoundingBrand } from '@retail/rounding/types';

export interface PriceDateProps {
  date: Date;
  priceExVat: Prices;
  priceIncVat: Prices;
  actualCoverageDegree?: number;
  actualSalesFactor?: number;
  bracketPricePercentage?: number;
  priceSuggestionType?: PriceSuggestionType;
  purchaseCondition?: PurchaseCondition;
  freightCondition?: FreightCondition;
  priceSuggestionCondition?: PriceSuggestionCondition;
  markupCondition?: MarkupCondition;
  customerMarkupCondition?: CustomerMarkupCondition;
  roundingCondition?: RoundingCondition;
}

export class PriceDate {
  date: Date;
  priceExVat: Prices;
  priceIncVat: Prices;
  actualCoverageDegree?: number;
  actualSalesFactor?: number;
  bracketPricePercentage?: number;
  priceSuggestionType?: PriceSuggestionType;
  purchaseCondition?: PurchaseCondition;
  freightCondition?: FreightCondition;
  priceSuggestionCondition?: PriceSuggestionCondition;
  markupCondition?: MarkupCondition;
  customerMarkupCondition?: CustomerMarkupCondition;
  roundingCondition?: RoundingCondition;

  constructor({
    date,
    priceExVat,
    priceIncVat,
    actualCoverageDegree,
    actualSalesFactor,
    bracketPricePercentage,
    priceSuggestionType,
    purchaseCondition,
    freightCondition,
    priceSuggestionCondition,
    markupCondition,
    customerMarkupCondition,
    roundingCondition,
  }: PriceDateProps) {
    this.date = date;
    this.priceExVat = priceExVat;
    this.priceIncVat = priceIncVat;
    this.actualCoverageDegree = actualCoverageDegree;
    this.actualSalesFactor = actualSalesFactor;
    this.bracketPricePercentage = bracketPricePercentage;
    this.priceSuggestionType = priceSuggestionType;
    this.purchaseCondition = purchaseCondition;
    this.freightCondition = freightCondition;
    this.priceSuggestionCondition = priceSuggestionCondition;
    this.markupCondition = markupCondition;
    this.customerMarkupCondition = customerMarkupCondition;
    this.roundingCondition = roundingCondition;
  }

  static fromDTO = (dto: PriceDateDTO, selectedBrand: PriceRoundingBrand): PriceDate =>
    new PriceDate({
      date: new Date(dto.date),
      priceExVat: Prices.fromDTO(dto.priceExVat),
      priceIncVat: Prices.fromDTO(dto.priceIncVat),
      actualCoverageDegree: dto.actualCoverageDegree,
      actualSalesFactor: dto.actualSalesFactor,
      bracketPricePercentage: dto.bracketPricePercentage,
      priceSuggestionType: dto.priceSuggestionType,
      purchaseCondition: dto.purchaseCondition
        ? PurchaseCondition.fromDto(dto.purchaseCondition)
        : undefined,
      freightCondition: dto.freightCondition
        ? FreightCondition.fromDto(dto.freightCondition)
        : undefined,
      priceSuggestionCondition: dto.priceSuggestionCondition
        ? PriceSuggestionCondition.fromDto(dto.priceSuggestionCondition)
        : undefined,
      markupCondition: dto.markupCondition
        ? MarkupCondition.fromDto(dto.markupCondition)
        : undefined,
      customerMarkupCondition: dto.customerMarkupCondition
        ? CustomerMarkupCondition.fromDto(dto.customerMarkupCondition)
        : undefined,
      roundingCondition: dto.roundingCondition
        ? RoundingCondition.fromDto(dto.roundingCondition, selectedBrand)
        : undefined,
    });
}
